import { UnitZonesPage } from '@apps-common/apps/portal/pages/units/pages/manage/pages/zones/Index'

export const UnitZones = () => <UnitZonesPage />
